import React from "react"
import OfertouLogo from "../../assets/logo-homepage.svg"
import Footer from "../../components/Footer"

const PrivacyPolicy: React.FC = () => {
  
  return (
    <div className="min-h-screen bg-[#e9e2db] flex flex-col">
      {/* Header - Matched with Home page header but without position sticky */}
      <header className="bg-[#e9e2db] py-5 px-4 sm:px-6 md:px-12 lg:px-24 w-full z-10">
        <div className="flex items-center justify-between max-w-[1400px] mx-auto">
          <a href="/" className="mr-8">
            <img src={OfertouLogo} alt="Ofertou Logo" width={130} height={45} className="h-10 w-auto" />
          </a>
          <nav className="hidden md:flex space-x-12">
            <a href="/app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
              Ofertas
            </a>
            <a
              href="/#como-funciona"
              className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors"
            >
              Como Funciona
            </a>
            <a href="https://espera.ofertou.app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
              Divulgar produtos
            </a>
          </nav>
          <div className="md:hidden flex items-center">
            <button className="p-2 text-[#212121]">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
      </header>

      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-800 mb-8 border-b pb-4">Política de Privacidade</h1>

          <div className="space-y-6 text-gray-600">
            <div className="flex justify-center mb-8">
              <img src={OfertouLogo} alt="Ofertou Logo" className="h-16 w-auto" />
            </div>
            
            <p className="leading-relaxed">
              A <span className="text-[#eb6813] font-medium">Ofertou</span> está comprometida em proteger a privacidade e os dados pessoais de nossos usuários. Esta Política de Privacidade descreve como coletamos, usamos, compartilhamos e protegemos suas informações quando você utiliza nossos serviços.
            </p>

            <section className="mt-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Informações que Coletamos</h2>
              <div className="pl-4 border-l-2 border-[#eb6813]/20">
                <p className="leading-relaxed mb-2">Podemos coletar os seguintes tipos de informações:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>Informações de cadastro (nome, e-mail, telefone)</li>
                  <li>Dados de uso e navegação em nossa plataforma</li>
                  <li>Informações sobre dispositivos e conexões</li>
                  <li>Dados de localização (quando permitido)</li>
                </ul>
              </div>
            </section>

            <section className="mt-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Como Utilizamos suas Informações</h2>
              <div className="pl-4 border-l-2 border-[#eb6813]/20">
                <p className="leading-relaxed mb-2">Utilizamos suas informações para:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>Fornecer, manter e melhorar nossos serviços</li>
                  <li>Processar transações e enviar notificações relacionadas</li>
                  <li>Personalizar sua experiência e oferecer conteúdo relevante</li>
                  <li>Comunicar-nos com você sobre atualizações, promoções e novidades</li>
                  <li>Garantir a segurança e integridade de nossa plataforma</li>
                </ul>
              </div>
            </section>

            <section className="mt-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Compartilhamento de Informações</h2>
              <div className="pl-4 border-l-2 border-[#eb6813]/20">
                <p className="leading-relaxed">
                  Podemos compartilhar suas informações com terceiros apenas nas seguintes circunstâncias:
                </p>
                <ul className="list-disc pl-5 space-y-2 mt-2">
                  <li>Com seu consentimento explícito</li>
                  <li>Com parceiros de negócios que nos ajudam a fornecer e melhorar nossos serviços</li>
                  <li>Quando exigido por lei ou para proteger direitos e segurança</li>
                </ul>
              </div>
            </section>

            <section className="mt-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Seus Direitos e Escolhas</h2>
              <div className="pl-4 border-l-2 border-[#eb6813]/20">
                <p className="leading-relaxed">
                  Você tem o direito de:
                </p>
                <ul className="list-disc pl-5 space-y-2 mt-2">
                  <li>Acessar, corrigir ou excluir seus dados pessoais</li>
                  <li>Retirar seu consentimento a qualquer momento</li>
                  <li>Optar por não receber comunicações de marketing</li>
                  <li>Solicitar a portabilidade de seus dados</li>
                </ul>
              </div>
            </section>

            <section className="mt-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Segurança de Dados</h2>
              <div className="pl-4 border-l-2 border-[#eb6813]/20">
                <p className="leading-relaxed">
                  Implementamos medidas técnicas e organizacionais apropriadas para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição.
                </p>
              </div>
            </section>

            <section className="mt-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Alterações nesta Política</h2>
              <div className="pl-4 border-l-2 border-[#eb6813]/20">
                <p className="leading-relaxed">
                  Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre quaisquer alterações significativas por meio de um aviso em nosso site ou por e-mail.
                </p>
              </div>
            </section>

            <div className="bg-[#f9f5f1] p-5 rounded-md mt-8">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Contato</h2>
              <p className="leading-relaxed">
                Se você tiver dúvidas ou preocupações sobre esta Política de Privacidade ou sobre como tratamos seus dados, entre em contato conosco pelo e-mail: <a href="mailto:contato@ofertou.app" className="text-[#eb6813] hover:underline">contato@ofertou.app</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default PrivacyPolicy